/* ═══════════════════════════════════════════════════════════
   FÉLIX · Locator de puntos de venta (Leaflet + CARTO)
   Pines con la flor de la marca, tarjetas sincronizadas con el
   mapa y filtros por zona. Sin API keys.
   ═══════════════════════════════════════════════════════════ */
(function(){
  'use strict';
  if(typeof L === 'undefined' || !window.PUNTOS_FELIX) return;

  var puntos = window.PUNTOS_FELIX;

  var mapa = L.map('mapa', {scrollWheelZoom:false, zoomControl:true}).setView([19.402,-99.17], 12);
  L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution:'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    maxZoom:19
  }).addTo(mapa);
  mapa.on('click', function(){ mapa.scrollWheelZoom.enable(); });

  var iconoFlor = function(activo){
    return L.divIcon({
      className:'pin-felix' + (activo ? ' activo' : ''),
      html:'<img class="pin-img" src="' + (window.FELIX_PIN || 'pin-manzana.png') + '" alt="">',
      iconSize:[34,34], iconAnchor:[17,30], popupAnchor:[0,-26]
    });
  };

  var marcadores = [], activo = -1;
  var carrusel = document.getElementById('carruselPuntos');

  function urlMaps(p){
    return 'https://www.google.com/maps/search/?api=1&query=' +
      encodeURIComponent(p.n + ' ' + p.d + ' CDMX');
  }

  puntos.forEach(function(p, i){
    var m = L.marker([p.lat, p.lng], {icon: iconoFlor(false), title: p.n}).addTo(mapa);
    m.bindPopup('<div class="popup-felix"><span>' + p.z + '</span><b>' + p.n + '</b>' +
      '<a href="' + urlMaps(p) + '" target="_blank" rel="noopener">Cómo llegar →</a></div>');
    m.on('click', function(){ activar(i, false); });
    marcadores.push(m);

    var card = document.createElement('article');
    card.className = 'punto-card';
    card.setAttribute('data-cat', p.c);
    card.innerHTML = '<span class="zona-card">' + p.z + '</span><h3>' + p.n + '</h3>' +
      '<address>' + p.d + '</address>' +
      '<a class="maps" href="' + urlMaps(p) + '" target="_blank" rel="noopener">Cómo llegar →</a>';
    card.addEventListener('click', function(e){
      if(e.target.tagName === 'A') return;
      activar(i, true);
    });
    carrusel.appendChild(card);
  });

  var cards = carrusel.querySelectorAll('.punto-card');

  function activar(i, volar){
    if(activo >= 0){
      marcadores[activo].setIcon(iconoFlor(false));
      cards[activo].classList.remove('activa');
    }
    activo = i;
    marcadores[i].setIcon(iconoFlor(true));
    cards[i].classList.add('activa');
    cards[i].scrollIntoView({behavior:'smooth', inline:'center', block:'nearest'});
    if(volar){
      mapa.flyTo([puntos[i].lat, puntos[i].lng], Math.max(mapa.getZoom(), 15), {duration:.7});
      marcadores[i].openPopup();
    }
  }

  function ajustar(cat){
    var visibles = [];
    puntos.forEach(function(p, i){
      var ok = (cat === 'todo') || (p.c === cat);
      cards[i].style.display = ok ? '' : 'none';
      if(ok){
        if(!mapa.hasLayer(marcadores[i])) marcadores[i].addTo(mapa);
        visibles.push(marcadores[i].getLatLng());
      } else if(mapa.hasLayer(marcadores[i])){
        mapa.removeLayer(marcadores[i]);
      }
    });
    if(visibles.length){
      mapa.flyToBounds(L.latLngBounds(visibles).pad(0.22), {duration:.7, maxZoom:15});
    }
  }

  var grupo = document.querySelector('[data-mapa-filtros]');
  if(grupo){
    grupo.addEventListener('click', function(e){
      var btn = e.target.closest('.filtro');
      if(!btn) return;
      grupo.querySelectorAll('.filtro').forEach(function(b){ b.classList.remove('activo'); });
      btn.classList.add('activo');
      ajustar(btn.getAttribute('data-cat'));
    });
  }

  ajustar('todo');
})();
